import {
  CustomerError,
  makeCustomerRequest
} from '@api/graphqlShopify/makeCustomerRequest'
import { CustomerDetailsData, CustomerDetailsSchema } from '../config'
import { Customer } from 'types/customer'
import { customerUpdateMutation } from '@api/graphqlShopify/mutations'
import { parse } from '@helpers/shopify'
import { CustomerApiQueryResponse } from '@components/account/types'
import { getErrorMessage } from '@api/graphqlShopify'
import trackError from '@helpers/trackError'

export async function customerUpdate(
  payload: CustomerDetailsData,
  token: string
) {
  try {
    const result = CustomerDetailsSchema.safeParse(payload)

    if (!result.success) {
      throw result.error
    }

    const { data } = await makeCustomerRequest<{
      customerUpdate: {
        userErrors: CustomerError[]
        customer: Customer
      }
    }>(
      customerUpdateMutation,
      {
        input: {
          firstName: payload.firstName,
          lastName: payload.lastName
        }
      },
      token
    )

    const { customerUpdate, userErrors } = parse(data.customerUpdate) as {
      customerUpdate: CustomerApiQueryResponse
      userErrors: CustomerError[]
    }

    if (userErrors?.length) {
      throw userErrors
    }

    return customerUpdate
  } catch (e) {
    const error = e as Error
    const errorMessage = getErrorMessage(error)
    trackError(new Error(`customerUpdate failed - ${errorMessage}`), {
      inpt: JSON.stringify(payload),
      error
    })
    throw error
  }
}
